// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"object-storage"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.5 20H17.5C20 20 23 18.5 23 15C23 11.5 20 10 18 10V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V10C4 10 1 11.5 1 15C1 18.5 4.11768 20 6 20C7.88232 20 12 20 12 15V12.75M9.5 14L12 11.5L14.5 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ObjectStorageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'object-storage',
    ref,
    icon: element,
  },
));

ObjectStorageIcon.displayName = 'ObjectStorageIcon';

export default ObjectStorageIcon;
